import SoundSample from './SoundSample.json';
import AppContext from '../../../common/context/AppContext';

function getAudio(name: string): HTMLAudioElement {
    const mimeType = SoundSample[name].mimeType;
    const base64 = SoundSample[name].base64;
    return new Audio('data:' + mimeType + ';base64,' + base64);
}

const notificationSound = getAudio('notification');

export class SoundUtils {
    static playNotificationSound() {
        if (AppContext.dashboardSettings.enableSoundNotification) {
            notificationSound.play();
        }
    }
}
